import { mockActivityTypeFilterOptions } from '@/lib/demo-data/activity-types';
import { useApi } from './useApi';
import { useModeAwareQuery } from './useModeAwareQuery';

interface ActivityTypeLookupApi {
  id: number;
  code: string;
  name: string;
  description: string | null;
}

export interface ActivityTypeFilterOption {
  value: string;
  label: string;
}

/**
 * Fetches the canonical ActivityTypes lookup and maps it into MultiSelect options.
 * Drives the Collections Queue "Last Action Type" filter so the dropdown shares one
 * vocabulary with the RecentActivities.ActivityTypeId writers.
 */
export function useActivityTypeFilterOptions() {
  const { apiGet } = useApi();

  return useModeAwareQuery<ActivityTypeFilterOption[], Error>(
    ['activity-type-filter-options'],
    async ({ signal }) => {
      const response = await apiGet<ActivityTypeLookupApi[]>('/api/v1/activity-types', undefined, signal);
      return response.map((t) => ({ value: t.code, label: t.name }));
    },
    mockActivityTypeFilterOptions,
    { staleTime: 60 * 1000, refetchOnWindowFocus: false },
  );
}
